import PropTypes from 'prop-types'
import _ from 'lodash'
import { LoadingScreen } from '../../../components/generic'
import { NoDataIcon, EmptyState, CrashIcon } from '@lmc/ui-kit'
import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import qs from 'qs'

export const DataSource = (props: any) => {
  const {
    errorMessage,
    noResultTitle,
    noResultDescription,
    renderError,
    renderSuccess,
    url,
    query,
    ...restProps
  } = props

  let fetchUrl = url
  if (query) fetchUrl += `?${qs.stringify(query)}`

  const { data, isLoading, error } = useQuery([fetchUrl], () =>
    getJSON({ url: fetchUrl })
  )

  if (isLoading) return <LoadingScreen {...restProps} />

  if (error) {
    const msg = errorMessage || error || 'Oops.. Something went wrong'
    return <EmptyState icon={<CrashIcon />} title={msg} {...restProps} />
  }

  if (data) {
    if (data.result.length) {
      return <div>{renderSuccess(data.result, data.count)}</div>
    }
    if (renderError) {
      return renderError()
    }
    return (
      <EmptyState
        icon={<NoDataIcon />}
        title={noResultTitle || 'No result'}
        description={noResultDescription}
      />
    )
  }
}

DataSource.propTypes = {
  dataFetch: PropTypes.object.isRequired,
  renderSuccess: PropTypes.func.isRequired,
  renderError: PropTypes.func,
  errorMessage: PropTypes.object,
  noResultTitle: PropTypes.string,
  noResultDescription: PropTypes.string,
}

export default DataSource
